<template>

  <section class="section index" id="index">
      <div class="container">
          <div class="section__heading" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
              <h2 class="section__title">Technology index</h2>
              <p class="section__intro">We use modern, proven technologies and approaches that let us build performant and easily scalable digital products for mobile, web, wearables, TV, and IoT.</p>
          </div>
          <ul class="list list--icons list--platforms">
              <li class="list__item" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
                  <div class="img-wrap"><img class="img" src="https://yalantis.com/assets/v3/icons/platforms/icon-web-9a56946bcabfe4005c769d21a1d4ef799042171ef1380daf534ffb4dc8b00a3c.svg" alt="" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div><span class="title">Web</span>
              </li>
              <li class="list__item" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
                  <div class="img-wrap"><img class="img" src="https://yalantis.com/assets/v3/icons/platforms/icon-ios-179930f103fe093c779cfc6ac8fac33e3101175c5c81763cc8269f7fa9e5998e.svg" alt="" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div><span class="title">iOS</span>
              </li>
              <li class="list__item" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
                  <div class="img-wrap"><img class="img" src="https://yalantis.com/assets/v3/icons/platforms/icon-android-65850262d7186ca4c0ac675cff6e8371085efe81bdb4d532565b35ab53c3760b.svg" alt="" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div><span class="title">Android</span>
              </li>
              <li class="list__item" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
                  <div class="img-wrap"><img class="img" src="https://yalantis.com/assets/v3/icons/platforms/icon-wearables-f09d454da45868798bba06c6102f7b3d7f7a52b62cbafc9994c43f7427a882d2.svg" alt="" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div><span class="title">Wearables</span>
              </li>
              <li class="list__item" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
                  <div class="img-wrap"><img class="img" src="https://yalantis.com/assets/v3/icons/platforms/icon-tv-159b4893a36bfdd70cfd348ef4024491ba9e02af6263c75e629f91d72c227af2.svg" alt="" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div><span class="title">TV</span>
              </li>
              <li class="list__item" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
                  <div class="img-wrap"><img class="img" src="https://yalantis.com/assets/v3/icons/platforms/icon-iot-8b529a6f18e5eae0e00309da788d62a81a92edc50cdcf1d807af87400e50b14b.svg" alt="" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div><span class="title">IoT</span>
              </li>
          </ul>
          <div class="section__control" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"><a class="btn btn--bordered btn--arrow" href="/technologies/" rel="nofollow">See our tech stack</a></div>
      </div>
  </section>

</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list--platforms{
    display:table;
    width:100%;
    margin:0
}
@media (max-width: 768px){
    .list--platforms{
        display:block;
        max-width:initial
    }
    .list--platforms:after{
        content:"";
        display:table;
        clear:both
    }
}
@media (max-width: 768px){
    .list--platforms .list__item{
        float:left;
        width:33.3%;
        margin:20px 0
    }
}
@media (max-width: 480px){
    .list--platforms .list__item{
        width:50%
    }
}
.list--platforms .img-wrap{
    margin-bottom:5px
}
@media (max-width: 768px){
    .list--platforms .img-wrap{
        margin-bottom:0
    }
}
@media (max-width: 768px){
    .list--platforms .title{
        font-size:20px
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue